const ROOM_FAILURES = new Set(["room-disconnected", "room-error"]);

export const getViewerRecoveryAction = (reason) => (
  ROOM_FAILURES.has(reason) ? "reconnect-room" : "check-active-room"
);

export const shouldForceViewerRoomReconnect = (reason) => (
  getViewerRecoveryAction(reason) === "reconnect-room"
);
